import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { firebaseConnect } from "react-redux-firebase";
import {
  openEditProfile,
  openCreateAccount,
  showAccountMenu,
  hideAccountMenu
} from "../actions/accountModalActions";
const queryString = require("query-string");

class CaAccountMenu extends React.Component {
  constructor(props) {
    super(props);
    this.logoutProfile = this.logoutProfile.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.hideTimeout;
    this.mouseOut = true;
  }

  componentWillUnmount() {
    window.removeEventListener("mousemove", this.onMouseMove);
  }

  componentDidMount() {
    document.body.classList.add("quiz-active");
    window.addEventListener("mousemove", this.onMouseMove);

    const parsed = queryString.parse(location.search);
    if (
      parsed !== undefined &&
      Object.hasOwnProperty.call(parsed, "register")
    ) {
      this.props.openCreateAccount();
    }
  }

  getDisplayName() {
    return (
      this.props.profile.name ||
      this.props.auth.displayName ||
      this.props.auth.email
    );
  }

  evalIsChildOfMe(target) {
    let currentNode = target;
    while (currentNode.parentNode) {
      if (
        currentNode.classList.length > 0 &&
        currentNode.classList.contains("AccountMenu")
      )
        return true;
      currentNode = currentNode.parentNode;
    }
    return false;
  }

  onMouseMove(e) {
    if (this.evalIsChildOfMe(e.target)) {
      this.mouseOut = false;
      clearTimeout(this.hideTimeout);

      if (!this.props.quiz.accountModalReducer.menuOpen) {
        this.props.showAccountMenu();
      }
    } else if (!this.mouseOut) {
      this.mouseOut = true;
      clearTimeout(this.hideTimeout);
      this.hideTimeout = setTimeout(() => {
        this.props.hideAccountMenu();
      }, 500);
    }
  }

  async logoutProfile() {
    try {
      this.props.firebase.logout();
    } catch (e) {
      console.log(res);
    }
  }

  render() {
    if (!this.props.auth.isLoaded) {
      return <div className={"AccountMenu"}></div>;
    }
    if (
      this.props.auth.isEmpty ||
      this.props.firebase.auth().currentUser.isAnonymous
    ) {
      return (
        <div className={"AccountMenu"}>
          <div className="AccountMenu__signInBtn">
            <button onClick={() => this.props.openCreateAccount()}>
              <span>Sign in</span>
            </button>
          </div>
        </div>
      );
    }
    return (
      <div className={"AccountMenu"}>
        <div className={"AccountMenu__accountBtnWrapper"}>
          <button className={"AccountMenu__accountBtn"}>
            <span>{this.getDisplayName()}</span>
          </button>
        </div>
        <div
          className={
            "AccountMenu__expandedContentWrapper" +
            (this.props.quiz.accountModalReducer.menuOpen
              ? " AccountMenu__expandedContentWrapper--open"
              : "")
          }
        >
          <div className={"AccountMenu__expandedContentInner"}>
            <ul className={"AccountMenu__expandedContent"}>
              <li
                className={"AccountMenu__item"}
                onClick={() => (window.location.href = "/profile")}
              >
                <span>Profile</span>
              </li>
              <li
                className={"AccountMenu__item"}
                onClick={() => this.props.openEditProfile()}
              >
                <span>Edit profile</span>
              </li>
              <li
                className={"AccountMenu__item"}
                onClick={() => this.logoutProfile()}
              >
                <span>Sign out</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.firebase.auth,
    quiz: state,
    profile: state.firebase.profile
  };
}

function mapDispatchToProps(dispatch) {
  return {
    openCreateAccount: (type, view, open) =>
      dispatch(openCreateAccount(type, view, open)),
    openEditProfile: (type, view, open) =>
      dispatch(openEditProfile(type, view, open)),
    showAccountMenu: () => dispatch(showAccountMenu()),
    hideAccountMenu: () => dispatch(hideAccountMenu())
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firebaseConnect()
)(CaAccountMenu);
